import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9ed001a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Last result: ")
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 1 }


import Container from '@/components/ui/Container.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    result: null
  },
  setup(__props: any) {

const props = __props as {
  result: string;
}



return (_ctx: any,_cache: any) => {
  return (props.result)
    ? (_openBlock(), _createBlock(Container, {
        key: 0,
        class: "overlay-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (props.result)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _hoisted_3,
                  (props.result.includes('.'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: props.result,
                        target: "_blank"
                      }, _toDisplayString(props.result), 9, _hoisted_4))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.result), 1))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})